<template>

</template>

<script>
    import {CrossStorageClient} from "cross-storage"
    import {HUB_SERVER} from "../../shared/utils";
    export default {
        name: "LocalStorage",
        created() {
            var storage = new CrossStorageClient(HUB_SERVER);
            storage.onConnect().then(() => {
                return storage.get('existingKey', 'newKey');
            }).then((res) => {
            }).catch((err) => {
            });
        }
    }
</script>

<style scoped>

</style>
